module.exports = __webpack_public_path__ + "static/logo-fa8076e9c709a5f53e30e4261c5a2aa9.svg";